import { createContext, useContext } from "react";
import PropTypes from "prop-types";

const ScrollContext = createContext(null);

export const ScrollProvider = ({ children, scrollContainerRef }) => {
  return <ScrollContext.Provider value={scrollContainerRef}>{children}</ScrollContext.Provider>;
};

ScrollProvider.propTypes = {
  children: PropTypes.node.isRequired,
  scrollContainerRef: PropTypes.object,
};

const useScrollContainer = () => {
  return useContext(ScrollContext);
};
// eslint-disable-next-line react-refresh/only-export-components
export default useScrollContainer;
